__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) { return typeof console !== "undefined" && console.warn && console.warn(msg); };
	var uniqueName = "uk_borrower_platform_flexipay_accounts";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@honeybadger-io/js", "6.10.1", function() { return __webpack_require__.e(663).then(function() { return function() { return __webpack_require__(7663); }; }); });
			register("classnames", "2.3.1", function() { return __webpack_require__.e(694).then(function() { return function() { return __webpack_require__(1694); }; }); });
			register("flexipay-pay-form", "3.0.15", function() { return Promise.all([__webpack_require__.e(525), __webpack_require__.e(166), __webpack_require__.e(303)]).then(function() { return function() { return __webpack_require__(7525); }; }); });
			register("moment", "2.29.4", function() { return __webpack_require__.e(426).then(function() { return function() { return __webpack_require__(2426); }; }); });
			register("react-dom", "18.2.0", function() { return Promise.all([__webpack_require__.e(164), __webpack_require__.e(166)]).then(function() { return function() { return __webpack_require__(4164); }; }); });
			register("react-router-dom", "6.3.0", function() { return Promise.all([__webpack_require__.e(677), __webpack_require__.e(166)]).then(function() { return function() { return __webpack_require__(6677); }; }); });
			register("react", "18.2.0", function() { return function() { return __webpack_require__(2791); }; }, 1);
			initExternal(2530);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};